export default {
  props: ['coursework'],
  template: '#group_step_template',
  data() {
    return {
      number: 0,
      name: this.coursework.group.joined ? 'Group' : 'Join Group',
      task: 'Join Group'
    };
  },
  computed: {
    isVisible() {
      return this.coursework.is_group;
    },
    isActive() {
      return this.isVisible;
    },
    isComplete() {
      return this.coursework.group.joined;
    }
  },
  methods: {
    joinGroup(event) {
      let self = this;
      let method = 'POST';
      let url = Kadenze.Routes.course_coursework_coursework_groups_path(self.coursework.course_id, self.coursework.id);

      let button = Ladda.create(event.target);
      if(button) button.start();

      let response = new Kadenze.AjaxRequest({
        type: method,
        url: url
      });

      response.done(function (response, status, xhr) {
        self.coursework.group = xhr.responseJSON;
        new Kadenze.Notice.success();
      });

      response.fail(function(xhr, status, msg) {
        new Kadenze.Notice.error(xhr.responseJSON);
      });
    }
  },
  created() {
    this.$parent.steps.push(this);
  }
};
